<template>
  <div class="man_list">
    <div class="info_img" v-for="(item,index) in list" :key="index">
      <img :src="item?item:'../../../../public/img/orderInfo2/mr.png'">
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
      }
    },
    props:['list']
  }
</script>

<style lang="scss" scoped>
  .info_img {
		width: 64px;
		height: 64px;
    margin-right: 16px;
    margin-bottom: 12px;
    & img {
      width: 100%;
      height: 100%;
    }
  }

  .man_list {
		display: flex;
    flex-wrap: wrap;
  }
</style>
